import {React,useEffect} from "react";
import {
  BrowserRouter  ,
  HashRouter,
  Route,
  Routes,
  useNavigate
} from "react-router-dom";
import {UserPrivacy}  from './components/user_privacy';
import {AppPrivate} from './components/app_private';
import {Home} from './components/home';
// import { UploadOutlined, UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import './routers.css';
import 'antd/dist/antd.css';

export const RouterConfig=() =>{
//   let navigate  = useNavigate();

  return (
    <HashRouter>
      <Routes>
        <Route exact path="/home" element={<Home />}>
            {/* <Home/> */}
        </Route>
        <Route exact path="/index" element={<Home />}>
            {/* <Home/> */}
        </Route>
        <Route exact path="/" element={<Home />}>
            
        </Route>
        <Route exact path="/user_privacy" element={<UserPrivacy/>} >
        </Route>

        <Route exact path="/app_private" element={<AppPrivate/>} >
        </Route>

      </Routes>
    </HashRouter>
  );
}

